module.exports = __webpack_public_path__ + "img/sword-fire-05.adb7ba29.png";